import { render } from "./PaymentMethods.vue?vue&type=template&id=6d95470a&scoped=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"

import "./PaymentMethods.vue?vue&type=style&index=0&id=6d95470a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d95470a"]])

export default __exports__